import { render, staticRenderFns } from "./BetslipLottoExtendedItem.vue?vue&type=template&id=ea6bfc70"
import script from "./BetslipLottoExtendedItem.vue?vue&type=script&lang=js"
export * from "./BetslipLottoExtendedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports